import { graphql } from '../gql';

export const RELAY_QUOTES = graphql(`
  query relayQuotes($token: String!, $cursor: String, $first: Int = 100, $startDate: Date, $endDate: Date, $utcOffset: Float) {
    relayQuotes(first: $first, after: $cursor, token: $token, startDate: $startDate, endDate: $endDate, utcOffset: $utcOffset) {
      edges {
        node {
          id
          uniqueID
          friendlyId
          status
          dateAdded
          referralCode {
            code
            description
          }
          businessLine {
            id
            displayName
          }
          axisStructuredData {
            clientFirstName
            clientLastName
            type
            industry
            subIndustry
          }
          structuredData {
            businessLegalName
            businessName
            businessTradeName
            contactName
          }
          vagoCommercialPackStructuredData {
            clientName
            transaction
            epicLookupCode
            cglLimit
            tiv
            cglPremium
            propertyPremium
            user
            aragBound
            avivaBound
            propertyBound
            liabilityBound
          }
          bindings {
            id
            label
            bound
            unboundReason
          }
          linkToDetailsPage
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);
